import t_08_2370 from './KZ.T.08.2370.svg'
import t_08_2370_b from './KZ.T.08.2370 black.svg'

export default [
  t_08_2370,
  t_08_2370_b,
]
